export enum DocumentCategory {
    CPF = 'CPF',
    CNPJ = 'CNPJ'
}